/**
 * Mock Auth service for LOCAL DEVELOPMENT ONLY
 * This bypasses Cognito authentication and returns a fake JWT token
 *
 * SECURITY: This will NOT work in production builds due to NODE_ENV checks
 */

class MockSession {
  getIdToken() {
    return {
      getJwtToken: () => {
        return "mock-jwt-token-for-local-development";
      },
    };
  }
}

class MockAuth {
  async currentSession() {
    return new MockSession();
  }

  async currentAuthenticatedUser() {
    return {
      username: "local-dev-user",
      attributes: {
        sub: "local-dev-user-id",
        email: "dev@localhost.com",
      },
    };
  }

  async signOut() {
    console.log("Mock sign out");
  }
}

export const mockAuth = new MockAuth();
